module.exports = __webpack_public_path__ + "img/add-paper.d082e096.svg";